/* Beqir Vatovci – Theme-Skript. Bewusst klein gehalten, ohne Bibliotheken. */
(() => {
  document.documentElement.classList.remove('no-js');

  /* ---------- Kopfzeile: Linie beim Scrollen, Höhe fürs Mobilmenü ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const setH = () => document.documentElement.style.setProperty('--header-h', header.getBoundingClientRect().bottom + 'px');
    const onScroll = () => { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    setH(); onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setH);
    const drawer = document.querySelector('[data-menu-drawer]');
    if (drawer) {
      drawer.addEventListener('toggle', () => {
        setH();
        document.body.style.overflow = drawer.open ? 'hidden' : '';
        drawer.closest('[data-header]')?.classList.toggle('menu-open', drawer.open);
      });
      drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => { drawer.open = false; }));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.open) drawer.open = false; });
    }
  }

  /* ---------- Ruhiges Einblenden beim Scrollen ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Produktseite: Menge + Preis je Variante ---------- */
  document.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
    const inp = b.parentElement.querySelector('input');
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  }));
  const priceEl = document.querySelector('[data-product-price]');
  if (priceEl) {
    document.querySelectorAll('[data-product-form] [name="id"]').forEach((el) => el.addEventListener('change', () => {
      const opt = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    }));
  }

  /* ---------- Widerrufsformular (§ 356a BGB) ---------- */
  const wf = document.querySelector('[data-withdrawal-form]');
  if (wf) {
    const server = (wf.dataset.server || '').replace(/\/+$/, '');
    const steps = [1, 2, 3].map((n) => wf.querySelector(`[data-step="${n}"]`));
    const err = wf.querySelector('[data-form-error]');
    const itemsField = wf.querySelector('[data-items]');
    const show = (n) => { steps.forEach((el, i) => { el.hidden = i !== n - 1; }); wf.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    const val = (n) => (wf.elements[n] ? String(wf.elements[n].value).trim() : '');
    const scope = () => wf.querySelector('[name="scope"]:checked').value;
    wf.querySelectorAll('[name="scope"]').forEach((r) => r.addEventListener('change', () => { itemsField.hidden = scope() !== 'teil'; }));

    const validate = () => {
      const checks = [
        ['name', !!val('name')],
        ['email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))],
        ['order', !!val('order')],
        ['items', scope() !== 'teil' || !!val('items')],
      ];
      let ok = true;
      checks.forEach(([f, good]) => { wf.querySelector(`[data-field="${f}"]`).classList.toggle('has-error', !good); if (!good) ok = false; });
      return ok;
    };
    const data = () => ({ name: val('name'), email: val('email'), order: val('order'), orderDate: val('orderDate'), scope: scope(), items: val('items'), message: val('message') });

    wf.querySelector('[data-next]').addEventListener('click', () => {
      err.classList.remove('is-visible');
      if (!validate()) { err.textContent = 'Da fehlt noch was – schau bei den markierten Feldern.'; err.classList.add('is-visible'); return; }
      const d = data();
      const rows = [['Name', d.name], ['E-Mail', d.email], ['Bestellnummer', d.order], ['Bestellt/erhalten am', d.orderDate],
        ['Widerruf', d.scope === 'alles' ? 'Die ganze Bestellung' : 'Nur: ' + d.items], ['Nachricht', d.message]];
      const dl = wf.querySelector('[data-summary]');
      dl.innerHTML = '';
      rows.filter((r) => r[1]).forEach(([k, v]) => {
        const dt = document.createElement('dt'); dt.textContent = k; dt.style.fontWeight = '600';
        const dd = document.createElement('dd'); dd.textContent = v; dd.style.margin = '0 0 .6rem';
        dl.append(dt, dd);
      });
      show(2);
    });
    wf.querySelector('[data-back]').addEventListener('click', () => show(1));

    wf.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = wf.querySelector('[data-submit]');
      const d = data();
      const result = wf.querySelector('[data-result]');
      if (!server) {
        // Ersatzweg: Nachricht über das Shopify-Kontaktformular an Beq
        const fb = document.getElementById('withdrawal-fallback');
        fb.querySelector('[name="contact[email]"]').value = d.email;
        fb.querySelector('[name="contact[name]"]').value = d.name;
        fb.querySelector('[name="contact[body]"]').value = `WIDERRUF\nBestellnummer: ${d.order}\nBestellt/erhalten: ${d.orderDate}\nUmfang: ${d.scope === 'alles' ? 'ganze Bestellung' : d.items}\nNachricht: ${d.message}\nZeitpunkt: ${new Date().toLocaleString('de-DE')}`;
        fb.submit();
        return;
      }
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const res = await fetch(server + '/api/widerruf', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) });
        const out = await res.json();
        if (!res.ok || !out.ok) throw new Error(out.error || 'Fehler');
        const when = new Date(out.receivedAt).toLocaleString('de-DE', { dateStyle: 'long', timeStyle: 'short' });
        result.textContent = `Eingegangen am ${when} Uhr. Deine Vorgangsnummer: ${out.ref}. ` +
          (out.mailSent ? `Die Bestätigung ist per E-Mail an ${d.email} unterwegs.` : 'Die Bestätigungs-Mail konnte gerade nicht verschickt werden – ich schicke sie dir so schnell wie möglich nach. Bitte mach dir einen Screenshot dieser Seite.');
        show(3);
      } catch (ex) {
        err.textContent = 'Das hat leider nicht geklappt: ' + ex.message + '. Bitte versuch es noch einmal oder schreib mir über das Kontaktformular.';
        err.classList.add('is-visible');
      } finally {
        btn.classList.remove('is-loading'); btn.disabled = false;
      }
    });

    if (/contact_posted=true/.test(location.search)) {
      wf.querySelector('[data-result]').textContent = 'Dein Widerruf ist bei mir eingegangen. Bitte mach dir zur Sicherheit einen Screenshot dieser Seite.';
      show(3);
    }
  }

  /* ---------- Porträt-Bestellformular ---------- */
  const form = document.querySelector('[data-portrait-form]');
  if (form) initPortraitForm(form);

  function initPortraitForm(form) {
    const RANK = { original: 0, private: 1, public: 2 };
    const radios = [...form.querySelectorAll('[data-package-radio]')];
    const frames = [...form.querySelectorAll('[data-frame-radio]')];
    const variantId = form.querySelector('[data-variant-id]');
    const engraving = form.querySelector('[data-engraving]');
    const engraveInput = form.querySelector('[data-engraving-input]');
    const engraveCount = form.querySelector('[data-engraving-count]');
    const engravePreview = form.querySelector('[data-engraving-preview]');
    /* Gravur live auf die Leiste schreiben. Leeres Feld: echtes Foto mit Gravur (Bild 3).
       Sobald getippt wird: Rahmenfoto ohne Text (Bild 2) + der getippte Text in der Gravur-Schrift.
       Herzen (❤ ♥) werden zum ausgefüllten Herz wie bei der Lasergravur. */
    const heart = '<svg class="frame-preview__heart" viewBox="0 0 32 29" aria-hidden="true"><path d="M16 29 2.6 15.6A8.3 8.3 0 0 1 14.4 3.8L16 5.4l1.6-1.6a8.3 8.3 0 0 1 11.8 11.8z"/></svg>';
    const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const showFrame = (index) => form.querySelectorAll('[data-frame-preview]').forEach((img) => img.classList.toggle('is-active', img.dataset.framePreview === index));
    const drawEngraving = () => {
      if (!engravePreview) return;
      const f = frames.find((x) => x.checked);
      const engrave = !!f && f.dataset.engrave === 'true';
      const typed = engraveInput ? engraveInput.value.trim() : '';
      const live = engrave && typed !== '';
      if (engrave) showFrame(live ? String(f.dataset.index - 1) : f.dataset.index);
      engravePreview.classList.toggle('is-active', live);
      if (!live) return;
      engravePreview.innerHTML = typed.split(/❤️?|♥️?|<3/).map(esc).join(heart);
      const stage = engravePreview.parentElement;
      engravePreview.style.transform = 'translate(-50%, -50%)';
      engravePreview.style.fontSize = (stage.clientWidth * (parseFloat(engravePreview.style.getPropertyValue('--gs')) || 7.5) / 100).toFixed(2) + 'px';
      const max = stage.clientWidth * (parseFloat(engravePreview.style.getPropertyValue('--gw')) || 60) / 100;
      const w = engravePreview.scrollWidth;
      if (w > max && max > 0) engravePreview.style.transform = 'translate(-50%, -50%) scale(' + (max / w).toFixed(3) + ')';
    };
    let variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variants]').textContent); } catch (e) { /* leer */ }
    // Preis wie im Shop: "99 €", "108,90 €"
    const money = (cents) => (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',')) + '\u00a0€';
    const findVariant = (pkg, frame) => variants.find((v) => v.o1 === pkg && (frame == null || v.o2 === frame));
    const steps = [...form.querySelectorAll('[data-kind-min]')];
    const service = form.querySelector('[data-service-field]');
    const sumName = form.querySelector('[data-summary-name]');
    const sumPrice = form.querySelector('[data-summary-price]');
    const sumShip = form.querySelector('[data-summary-shipping]');
    const errorBox = form.querySelector('[data-form-error]');
    const submit = form.querySelector('[data-submit]');
    const maxBytes = (parseInt(form.dataset.maxMb, 10) || 20) * 1024 * 1024;

    // Paket aus URL (?paket=2) oder aus Klick auf eine Paketkarte übernehmen
    const select = (pos) => {
      const r = radios.find((x) => x.dataset.position === String(pos) && !x.disabled);
      if (r) { r.checked = true; update(); }
    };
    const urlPos = new URLSearchParams(location.search).get('paket');
    document.querySelectorAll('[data-select-package]').forEach((a) => {
      if (a.getAttribute('href').startsWith('#')) {
        a.addEventListener('click', () => select(a.dataset.selectPackage));
      }
    });

    function update() {
      const r = radios.find((x) => x.checked) || radios[0];
      if (!r) return;
      const rank = RANK[r.dataset.kind] ?? 0;
      steps.forEach((fs) => {
        const on = rank >= RANK[fs.dataset.kindMin];
        fs.hidden = !on;
        fs.disabled = !on; // deaktivierte Felder werden nicht übertragen
      });
      // Schritt-Nummern fortlaufend halten
      let n = 0;
      form.querySelectorAll('.form-step').forEach((fs) => {
        const num = fs.querySelector('.form-step__title span');
        if (num && !fs.hidden) num.textContent = ++n;
      });
      const label = r.closest('.choice').querySelector('.choice__name').textContent.trim();
      if (service) service.value = r.dataset.service || label;

      // Rahmen: passende Variante (Paket × Rahmen) wählen, Vorschau und Aufpreise aktualisieren
      const f = frames.find((x) => x.checked) || frames[0];
      const frameName = f ? f.value : null;
      let v = r.dataset.option ? findVariant(r.dataset.option, frameName) : null;
      if (!v && r.dataset.option) v = findVariant(r.dataset.option, frames[0] && frames[0].value);
      if (variantId) variantId.value = v ? v.id : r.value;
      if (f) {
        const base = findVariant(r.dataset.option, frames[0].value);
        frames.forEach((x) => {
          const fv = findVariant(r.dataset.option, x.value);
          const out = x.closest('.choice').querySelector('[data-frame-surcharge]');
          if (out && fv && base) out.textContent = '+' + money(fv.price - base.price);
          x.disabled = !fv || !fv.available;
        });
        showFrame(f.dataset.index);
        const engrave = f.dataset.engrave === 'true';
        if (engraving) { engraving.hidden = !engrave; engraveInput.disabled = !engrave; }
        drawEngraving();
      }
      const withFrame = f && f !== frames[0];
      if (sumName) sumName.textContent = label + (withFrame ? ' + ' + frameName : '');
      if (sumPrice) sumPrice.textContent = v ? money(v.price) : r.dataset.price;
      if (sumShip) sumShip.textContent = r.dataset.shipping || '';
    }
    frames.forEach((x) => x.addEventListener('change', update));
    if (engraveInput) {
      const count = () => { engraveCount.textContent = engraveInput.value.length + '/25'; };
      engraveInput.addEventListener('input', () => { count(); drawEngraving(); }); count();
      window.addEventListener('resize', drawEngraving);
    }
    radios.forEach((r) => r.addEventListener('change', update));
    if (urlPos) select(urlPos); else update();

    /* Foto: prüfen, Vorschau zeigen, im Original hochladen */
    const input = form.querySelector('[data-photo-input]');
    const zone = form.querySelector('[data-dropzone]');
    const preview = form.querySelector('[data-preview]');
    const pImg = form.querySelector('[data-preview-img]');
    const pName = form.querySelector('[data-preview-name]');
    const pMeta = form.querySelector('[data-preview-meta]');
    const okTypes = /^image\/(jpe?g|png|heic|heif|webp)$/i;
    const okExt = /\.(jpe?g|png|heic|heif|webp)$/i;
    let busy = false;

    // Eigener Foto-Server (Cloudflare): Foto wird sofort beim Auswählen bitgenau hochgeladen.
    // Klappt das nicht, geht die Datei als Ersatz ganz normal mit dem Formular an Shopify.
    const server = (form.dataset.server || '').replace(/\/+$/, '');
    const photoUrl = form.querySelector('[data-photo-url]');
    const photoMeta = form.querySelector('[data-photo-meta]');
    const progress = form.querySelector('[data-progress]');
    const inputName = input.name;
    let xhr = null;
    let uploading = null;
    let pending = false;

    const clearServerUpload = () => {
      if (xhr) xhr.abort();
      xhr = null; uploading = null; pending = false;
      if (photoUrl) { photoUrl.value = ''; photoUrl.disabled = true; }
      if (photoMeta) { photoMeta.value = ''; photoMeta.disabled = true; }
      input.name = inputName;
      if (progress) progress.hidden = true;
    };

    const uploadToServer = (file, attempt = 1) => new Promise((resolve, reject) => {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const person = form.querySelector('[name="properties[Dargestellte Person]"]');
      if (person) fd.append('person', person.value);
      xhr = new XMLHttpRequest();
      xhr.open('POST', server + '/api/upload');
      xhr.timeout = 10 * 60 * 1000;
      xhr.upload.onprogress = (ev) => {
        if (!ev.lengthComputable) return;
        const pct = Math.round((ev.loaded / ev.total) * 100);
        progress.firstElementChild.style.width = pct + '%';
        pMeta.dataset.status = `wird hochgeladen … ${pct} %`;
        renderMeta();
      };
      xhr.onload = () => {
        let res = null;
        try { res = JSON.parse(xhr.responseText); } catch (e) { /* leer */ }
        if (xhr.status === 200 && res && res.ok) resolve(res);
        else reject(new Error((res && res.error) || 'Upload fehlgeschlagen'));
      };
      xhr.onerror = xhr.ontimeout = () => reject(new Error('Verbindung unterbrochen'));
      xhr.onabort = () => reject(new Error('abgebrochen'));
      xhr.send(fd);
    }).catch((err) => {
      if (err.message !== 'abgebrochen' && attempt < 2) return uploadToServer(file, attempt + 1);
      throw err;
    });

    let baseMeta = '';
    const renderMeta = () => { pMeta.textContent = baseMeta + (pMeta.dataset.status ? ' · ' + pMeta.dataset.status : ''); };

    const fmt = (b) => (b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.round(b / 1024) + ' KB');
    const fieldOf = (el) => el.closest('[data-field]');
    const setErr = (el, on, msg) => {
      const f = fieldOf(el); if (!f) return;
      f.classList.toggle('has-error', on);
      const c = f.querySelector('.check'); if (c) c.classList.toggle('has-error', on);
      if (msg) { const e = f.querySelector('.field__error'); if (e) e.textContent = msg; }
    };

    const resetPhoto = () => {
      clearServerUpload();
      input.value = '';
      preview.classList.remove('is-visible');
      zone.style.display = '';
      if (pImg.src.startsWith('blob:')) URL.revokeObjectURL(pImg.src);
      pImg.removeAttribute('src');
    };
    form.querySelector('[data-preview-remove]').addEventListener('click', () => { resetPhoto(); input.click(); });

    ['dragenter', 'dragover'].forEach((ev) => zone.addEventListener(ev, (e) => { e.preventDefault(); zone.classList.add('is-drag'); }));
    ['dragleave', 'drop'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.remove('is-drag')));

    input.addEventListener('change', async () => {
      const file = input.files && input.files[0];
      if (!file) return;
      if (!(okTypes.test(file.type) || okExt.test(file.name))) {
        resetPhoto(); setErr(input, true, 'Dieses Dateiformat geht leider nicht. Bitte JPG, PNG oder HEIC wählen.'); return;
      }
      if (file.size > maxBytes) {
        resetPhoto(); setErr(input, true, `Die Datei ist zu groß (${fmt(file.size)}). Maximal ${fmt(maxBytes)}.`); return;
      }
      setErr(input, false, 'Bitte lade ein Foto als Vorlage hoch.');
      busy = true;
      pName.textContent = file.name;
      pMeta.textContent = fmt(file.size) + ' · wird vorbereitet …';
      preview.classList.add('is-visible');
      zone.style.display = 'none';

      // Die Datei wird NIE verändert: Beq braucht das Original in voller Qualität.
      // Das Bild wird hier nur für die Vorschau angezeigt (JPG/PNG/WebP, HEIC in Safari).
      clearServerUpload();
      pMeta.dataset.status = server ? 'wird hochgeladen …' : '';
      try {
        const url = URL.createObjectURL(file);
        const img = await loadImage(url);
        pImg.src = url;
        baseMeta = `${img.naturalWidth} × ${img.naturalHeight} px · ${fmt(file.size)}`;
        if (Math.min(img.naturalWidth, img.naturalHeight) < 1000) {
          baseMeta += ' · eher kleine Auflösung – hast du das Foto in besserer Qualität?';
        }
      } catch (e) {
        // z. B. HEIC in Chrome/Android: keine Vorschau möglich, Datei wird trotzdem übertragen
        pImg.removeAttribute('src');
        baseMeta = `${fmt(file.size)} · Vorschau hier nicht möglich, das Foto kommt trotzdem an`;
      }
      renderMeta();
      busy = false;

      if (server) {
        progress.hidden = false;
        progress.firstElementChild.style.width = '0';
        pending = true;
        uploading = uploadToServer(file).then((res) => {
          photoUrl.value = res.url;
          photoUrl.disabled = false;
          photoMeta.value = `${file.name} · ${fmt(file.size)} · Original`;
          photoMeta.disabled = false;
          input.removeAttribute('name'); // Datei nicht zusätzlich an Shopify schicken
          pMeta.dataset.status = 'hochgeladen ✓';
          progress.firstElementChild.style.width = '100%';
        }).catch((err) => {
          if (err.message === 'abgebrochen') return;
          input.name = inputName; // Ersatz: Datei geht mit dem Formular an Shopify
          pMeta.dataset.status = 'wird beim Bestellen übertragen';
          progress.hidden = true;
        }).finally(() => { xhr = null; pending = false; renderMeta(); });
      }
    });

    function loadImage(src) {
      return new Promise((res, rej) => {
        const i = new Image();
        i.decoding = 'async';
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = src;
      });
    }

    /* Prüfen vor dem Absenden */
    form.addEventListener('input', (e) => { if (e.target.matches('input, select, textarea')) setErr(e.target, false); });
    form.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox], select')) setErr(e.target, false); });

    form.addEventListener('submit', (e) => {
      errorBox.classList.remove('is-visible');
      if (busy) { e.preventDefault(); return; }

      const required = [...form.querySelectorAll('[required]')].filter((el) => !el.disabled && !el.closest('fieldset[disabled]'));
      let first = null;
      required.forEach((el) => {
        const bad = el.type === 'checkbox' ? !el.checked : el.type === 'file' ? !(el.files && el.files.length) : !String(el.value).trim();
        setErr(el, bad);
        if (bad && !first) first = el;
      });
      if (first) {
        e.preventDefault();
        errorBox.textContent = 'Da fehlt noch was – schau bei den markierten Feldern.';
        errorBox.classList.add('is-visible');
        const target = fieldOf(first) || first;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => (first.type === 'file' ? zone : first).focus({ preventScroll: true }), 350);
        return;
      }
      // Foto lädt noch zum Foto-Server: kurz warten, dann automatisch weiter
      if (pending && uploading) {
        e.preventDefault();
        submit.classList.add('is-loading');
        errorBox.textContent = 'Dein Foto wird noch hochgeladen – einen Moment, dann geht es automatisch weiter.';
        errorBox.classList.add('is-visible');
        uploading.finally(() => {
          errorBox.classList.remove('is-visible');
          submit.classList.remove('is-loading');
          form.requestSubmit ? form.requestSubmit(submit) : submit.click();
        });
        return;
      }
      // Leere optionale Angaben nicht mitschicken – die Bestellung bleibt übersichtlich
      form.querySelectorAll('[name^="properties["]').forEach((el) => {
        if (!el.disabled && el.type !== 'file' && el.type !== 'checkbox' && el.type !== 'hidden' && !String(el.value).trim()) {
          el.disabled = true;
          el.dataset.autoDisabled = '1';
        }
      });
      submit.classList.add('is-loading');
      submit.setAttribute('aria-disabled', 'true');
      // Doppel-Absenden verhindern, Formular läuft normal (mit Datei) an Shopify
      setTimeout(() => { submit.disabled = true; }, 0);
    });

    // Zurück-Button im Browser: Ladezustand zurücksetzen
    window.addEventListener('pageshow', () => {
      submit.classList.remove('is-loading');
      submit.removeAttribute('aria-disabled');
      submit.disabled = false;
      form.querySelectorAll('[data-auto-disabled]').forEach((el) => { el.disabled = false; delete el.dataset.autoDisabled; });
      update();
    });

    /* Mobiler Sticky-Button: sichtbar, solange das Formular nicht im Bild ist */
    const sticky = document.querySelector('[data-sticky-cta]');
    const section = document.getElementById('bestellen');
    if (sticky && section && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-cta');
      let pastHero = false, formVisible = false;
      const render = () => {
        const on = pastHero && !formVisible;
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.querySelector('a').tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(([en]) => { formVisible = en.isIntersecting; render(); }, { threshold: 0 }).observe(section);
      window.addEventListener('scroll', () => { pastHero = window.scrollY > window.innerHeight * 0.6; render(); }, { passive: true });
    }
  }

  /* ---------- Vorher / Nachher-Schieber ---------- */
  document.querySelectorAll('[data-compare]').forEach((box) => {
    const range = box.querySelector('[data-compare-range]');
    const set = (v) => { v = Math.max(0, Math.min(100, v)); box.style.setProperty('--pos', v + '%'); if (range) range.value = v; };
    if (range) range.addEventListener('input', () => set(+range.value));
    // Ziehen per Finger/Maus irgendwo im Bild (iOS lässt Range-Felder sonst nur am Griff ziehen)
    let drag = false;
    const fromEvent = (e) => { const r = box.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    box.addEventListener('pointerdown', (e) => { drag = true; box.setPointerCapture(e.pointerId); fromEvent(e); e.preventDefault(); });
    box.addEventListener('pointermove', (e) => { if (drag) fromEvent(e); });
    ['pointerup', 'pointercancel'].forEach((t) => box.addEventListener(t, () => { drag = false; }));
  });
})();
